import { FC } from 'react';
import dayjs from 'dayjs';

import { Box, Button, Typography } from '@thirdspacelearning/library';

interface Props {
    sessionPlannedAt: dayjs.Dayjs | null;
}

const SessionPlannedToday: FC<Props> = ({ sessionPlannedAt }) => {
    return (
        <Box
            display="flex"
            justifyContent="center"
            alignItems="center"
            width="100%"
            flexGrow={1}
            px={4}
            py={2}
        >
            <Box display="flex" flexDirection="column" mr={1} flexGrow={1}>
                <Typography
                    variant="h5"
                    fontWeight="bold"
                    data-testid="sessionPlannedAtText"
                >
                    Your tutoring session today is at{' '}
                    {sessionPlannedAt && sessionPlannedAt.format('h:mma')}
                </Typography>
                <Typography variant="subtitle2">
                    When your session is ready to start you’ll see a pop up
                    inviting you to join your tutor.
                </Typography>
            </Box>
            <Box flexShrink={0}>
                <Button
                    variant="contained"
                    color="primary"
                    size="small"
                    disabled
                >
                    Your tutor is getting ready...
                </Button>
            </Box>
        </Box>
    );
};

export default SessionPlannedToday;
